import React from 'react';
import './page.css';
import './../index.css';
import OrderHistory from "./OrderHistory";
import {isMobile, orderType} from "../util/Common";

class RejectHistory extends React.Component {
    render() {
        let isMobileL = isMobile();
        return(
            <OrderHistory status={orderType.reject} byUser={false} isMobile={isMobileL}/>
        )
    }
}

export default RejectHistory;